import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import React from 'react'
import './faq.scss'
import Arrow from './Arrow'




export default function Faq() {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };


  return (
    <div className="faq">
      <div className="faq__fone1"></div>
      <div className="faq__container">
        <span className="span-text">
          FAQ
        </span>
        <Typography variant='h2'>
          Популярные вопросы
        </Typography>
        <div className="faq-acs">
          <Accordion className='faq-ac' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Хочу пользоваться сервисом, но боюсь, что всплывающие окна испортят мой сайт?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              В нашем сервисе вы можете помимо виджета отдельно создать чат-бота 
  в социальной сети. В нужной части сайта вы пишете текст с призывом 
  подписаться на ваши сообщества в социальных сетях за лид-магнит и даёте ссылку на чат-бота.
              </Typography>
            </AccordionDetails>
          </Accordion >
          
		  <Accordion className='faq-ac' expanded={expanded === 'panel1_2'} onChange={handleChange('panel1_2')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Можно ли использовать сервис, если нет сайта?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              Да! Наш сервис дает удобную возможность создать маркетинговую связку виджет + чат-бот + рассылка. 
			  Вы можете использовать только чат-бот и рассылку. Например, при закупке рекламы в Телеграме лить трафик на бота,
			  который выдает лид-магнит за подписку. Затем вы можете сделать рассылку по всем людям, писавшим боту. 
              </Typography>
            </AccordionDetails>
          </Accordion >
		  
		  <Accordion className='faq-ac' expanded={expanded === 'panel1_3'} onChange={handleChange('panel1_3')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Можно ли адаптировать дизайн виджета под сайт?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              Да, очень легко. У нас есть возможность выбрать цветовую гамму для виджета.
              </Typography>
            </AccordionDetails>
          </Accordion >
		  
		  <Accordion className='faq-ac' expanded={expanded === 'panel1_4'} onChange={handleChange('panel1_4')}>
            <AccordionSummary
              expandIcon={<Arrow />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className='faq-ac-sum'
            >
              <Typography className='faq-ac-sum__t'>Я не программист, но у меня есть сайт. Смогу ли я установить на него виджет?</Typography>
            </AccordionSummary>
            <AccordionDetails className='faq-ac-det'>
              <Typography className='faq-ac-det__t'>
              Да. Напишите в тех. поддержку, мы поможем.
              </Typography>
            </AccordionDetails>
          </Accordion >
        </div>
      </div>
      <div className="faq__fone2"></div>
    </div>
  )
}